<div class="page-content scroll-fix">
    <div class="login-form">

        <div class="login-wrapper">
            <div class="login-body">

                <div class="row no-gutters align-items-center mb-5">
                    <div class="col-size">
                        <app-logo [size]="'30px'"></app-logo>
                    </div>

                    <div class="col">
                        <app-logo-project [size]="'30px'" class="ml-5"></app-logo-project>
                    </div>

                    <div class="col-size">
                        <div class="app-subname">{{ 'LOGIN.APP_SUBNAME' | translate }}</div>
                    </div>
                </div>

                <div class="panel-log-in">
                    <form>
                        <div class="row">
                            <div class="col-12">
                                <div class="col-12 mt-2">
                                    <app-input [label]="'LABEL.PASSWORD.NEW_PASSWORD' | translate"
                                               [uppercase]="false"
                                               [(ngModel)]="password"
                                               [ngModelOptions]="{standalone:true}"
                                               [errorStateMatcher]="matchers.password"
                                               autocomplete="off" name="password"
                                               suffixIconClass="icon-password"
                                               type="password">
                                    </app-input>
                                </div>

                                <div class="col-12 mt-2">
                                    <app-input [label]="'LABEL.PASSWORD.NEW_PASSWORD_REPEAT' | translate"
                                               [uppercase]="false"
                                               [(ngModel)]="password2"
                                               [ngModelOptions]="{standalone:true}"
                                               [errorStateMatcher]="matchers.password2"
                                               autocomplete="off" name="password"
                                               suffixIconClass="icon-password"
                                               type="password">
                                    </app-input>
                                </div>

                                <div class="col-12 mt-2">
                                    <button class="btn btn-block btn-primary"
                                            (click)="submit()"
                                            type="submit">
                                        {{ 'BUTTON.CONFIRM' | translate }}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
            <div class="login-information">
                <div class="row">
                    <div class="col-size">
                        <i class="icon-info-filled"></i>
                    </div>
                    <div class="col" [innerHTML]="'LABEL.PASSWORD.INFORMATION' | translate"></div>
                </div>
            </div>
        </div>
    </div>
</div>
